import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "paymongo"
    }}>{`Paymongo`}</h2>
    <p>{`The PayMongo API allows you to build customized and unique payment experiences for your website, application or service. Our goal is to give you access to pretty much all the necessary resources to integrate payments into your platform.`}</p>
    <h3 {...{
      "id": "paymongo-integrate-inside-pickbazar"
    }}>{`Paymongo integrate inside PickBazar.`}</h3>
    <p>{`Please follow & complete this steps for Paymongo integration for your e-commerce system.`}</p>
    <ul>
      <li parentName="ul">{`Inside api there is `}<inlineCode parentName="li">{`.env`}</inlineCode>{` file. You have to copy & paste this line of codes inside the `}<inlineCode parentName="li">{`.env`}</inlineCode>{` file. We will discuss later about how to create those API keys in Paymongo.`}</li>
    </ul>
    <pre><code parentName="pre" {...{}}>{`PAYMONGO_PUBLIC_KEY=[YOUR_PAYMONGO_PUBLIC_KEY]
PAYMONGO_SECRET_KEY=[YOUR_PAYMONGO_SECRET_KEY]

# Paymongo Webhook settings

PAYMONGO_WEBHOOK_SIG=[YOUR_PAYMONGO_WEBHOOK_URL]
`}</code></pre>
    <ul>
      <li parentName="ul">{`To activate Paymongo go to settings from PickBazar admin dashboard. Inside settings you will find configure payment option. (e.g. webhook URL is coming from local development. This static link will dynamically generated in live environment)`}</li>
    </ul>
    <p><img alt="admin-pickbazar-settings" src={require("../images/payment-images/admin-settings.jpg")} />{`
`}<img alt="paymongo_currency" src={require("../images/payment-images/paymongo_currency.png")} />{`
`}<img alt="paymongo_payment_geteway" src={require("../images/payment-images/paymongo_payment_geteway.png")} />{`
`}<img alt="paymongo_key" src={require("../images/payment-images/paymongo_key.png")} /></p>
    <h2 {...{
      "id": "how-to-create-paymongo-webhook-url"
    }}>{`How to create paymongo webhook url?`}</h2>
    <ul>
      <li parentName="ul">{`Open your terminal in API project for artisan commend`}</li>
    </ul>
    <ul>
      <li parentName="ul">{`Then run this commend`}</li>
    </ul>
    <pre><code parentName="pre" {...{}}>{`php artisan paymongo:webhook
`}</code></pre>
    <h2 {...{
      "id": "you-can-visit-for-paymongo"
    }}>{`You can visit for paymongo.`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developers.paymongo.com/docs"
        }}>{`paymongo official documentation`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://paymongo.rigelkentcarbonel.com/webhooks"
        }}>{`paymongo Webhooks documentation`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      